export const DEFAULT_ICON = 'dropdown';
export const SORTABLE_ACCORDION_HELPER_CLASSNAME = 'custom-page-sortable-accordion-panel-helper';
export const SORTABLE_ACCORDION_AXIS = 'y';

export const DELETE_ACCORDION_PANEL_CONFIRM_HEADER = 'Delete Accordion Panel';
export const DELETE_ACCORDION_PANEL_CONFIRM_CONTENT =
  'Are you sure you want to delete this accordion panel? This action cannot be undone.';
